import React, {Component} from 'react';
import {  Link } from 'react-router-dom';
import axios from 'axios';
// const querystring = require('querystring');
export default class ManageWorkflow extends Component {

	constructor(props)
	{
		console.log(props);
		super(props);
				let parms = ""; 
// 				JSON.stringify(querystring.parse(this.props.location.search)).replace('?', '');
        console.log("parms => " + parms);

		this.state={
			workflow : {
				"workflowId": 0,
				"workflowName": "",
				"workflowTypeCode": 0,
				"description": "",
				"statusCode": 0,
				"workflowCases" : "",
				"annotations": "",
				"contentId": 0,
				"securityContextId": 0,
				"createUser": Number(this.props.userId),
				"createDate": new Date(),
				"lastUpdateUser": Number(this.props.userId),
				"lastUpdateDate": new Date(),
				"managerId": 0,
			  	"ownerId": Number(this.props.userId),
			  	"assignees": "",
			  	"projectId": 0,
			  	"recipeId": 0
			  },
			  statusCodeList : [],
			  workflowTypeCodeList : []
		}
		this.handleChange = this.handleChange.bind(this);
		this.handleSubmit = this.handleSubmit.bind(this);
		this.handleOnLoad = this.handleOnLoad.bind(this);
	}
	handleChange(event) {
		//event.preventDefault();
		var target = event.target;
		console.log(target.id + ":" + target.value);
		this.setState({workflow : {...this.state.workflow, [target.id] : target.value } });	   
		console.log(this.state);
	  }

	handleSubmit(event) {

		event.preventDefault();
		console.log('handling submit');  
	
	  	var url = `${global.config.apiServicesUrl}/workflows`;
  		var idUrl = `${global.config.securityServicesUrl}/next-id-generator/get-next/workflows/workflowId`;
	
  		axios.get(idUrl)
	  		.then(response => {
	  		const nextWorkflowId = response.data["nextId"];
		  	this.setState({workflow : {...this.state.workflow, workflowId : nextWorkflowId } });
		  	this.setState({workflow : {...this.state.workflow, createUser : Number(this.props.userId) } });
			this.setState({workflow : {...this.state.workflow, lastUpdateUser : Number(this.props.userId) } });
			this.setState({workflow : {...this.state.workflow, createDate : new Date() } });
			this.setState({workflow : {...this.state.workflow, lastUpdateDate : new Date() } });
		  	//console.log("new category id = " + JSON.stringifyt(this.state.workflow.contentCategoriesObject.contentCategoryId));
	
			console.log("request object = " + JSON.stringify(this.state));
	  		//this.state.workflow.lastUpdateUser = Number(this.props.userId);

			axios
			  .post(url, this.state.workflow)
			  .then(response2 => {
				console.log("response.data");
				console.log(response2.status +":"+response2.data.accountId);
			// && response2.data.contentFacadeId === this.state.workflow.contentFacadeId
				if (response2.status === 200 )
				{
					this.message = "Success";
				}
				else
				{
				 	this.message = "Failed";
				}        
				console.log(this.message);
			 // 
				event.preventDefault();
			//response.send(this.message);
			
		  	})
			.catch(err => {
				console.log("error - " + err);
		  	});
			console.log("message info - " + this.message); 
			this.handleClear();
			window.location.href = "/workflows";			
		});
			
	 };
	 handleClear(){
		 this.setState({workflow : {
				"workflowId": 0,
				"workflowName": "",
				"workflowTypeCode": 0,
				"description": "",
				"statusCode": 0,
				"workflowCases" : "",
				"annotations": "",
				"contentId": 0,
				"securityContextId": 0,
				"createUser": Number(this.props.userId),
				"createDate": new Date(),
				"lastUpdateUser": Number(this.props.userId),
				"lastUpdateDate": new Date(),
				"managerId": 0,
			  	"ownerId": Number(this.props.userId),
			  	"assignees": "",
			  	"projectId": 0,
			  	"recipeId": 0
			  }})
	 }
	 componentDidMount() 
	 {
	 	this.handleOnLoad();
	 }

	handleOnLoad = () => {
		 this.setState({workflow : {}});

 			//resolve drop down lists
			{
				//statusCodeList : [],
				var url1 = `${global.config.sharedServicesUrl}/code-catalog-data-service/get-system-code-values/TASK_STATUS`;
					axios.get(url1)
					.then(response =>{
 					this.setState({statusCodeList : response.data});
					}).catch(function (error) {
						console.log("Error:"+error);
					});		
				//workflowTypeCodeList
				var url2 = `${global.config.sharedServicesUrl}/code-catalog-data-service/get-system-code-values/WORK_QUEUE`;
					axios.get(url2)
					.then(response =>{
 					this.setState({workflowTypeCodeList : response.data});
					}).catch(function (error) {
						console.log("Error:"+error);
					});		
			}		 
		 
	 }
	
	render(){
    return (
        				<div class="m-content">				
			<div class="m-grid__item m-grid__item--fluid m-grid m-grid--ver-desktop m-grid--desktop m-body">
       				<div class="m-grid__item m-grid__item--fluid m-wrapper">
					<div class="m-subheader ">					
						<div class="d-flex align-items-center">
							<div class="mr-auto">
								<h3 class="m-subheader__title m-subheader__title--separator">Gazelle VLM</h3>
								<ul class="m-subheader__breadcrumbs m-nav m-nav--inline">
									<li class="m-nav__item m-nav__item--home">
										<Link to="/" class="m-nav__link m-nav__link--icon">
											<i class="m-nav__link-icon la la-home"></i>
										</Link>
									</li>
									<li class="m-nav__separator">-</li>
									<li class="m-nav__item">
										<Link to="/" class="m-nav__link">
											<span class="m-nav__link-text">Home</span>
										</Link>
									</li>
								</ul>
							</div>
							<div>
								<span class="m-subheader__daterange" id="m_dashboard_daterangepicker">
									<span class="m-subheader__daterange-label">
										<span class="m-subheader__daterange-title"></span>
										<span class="m-subheader__daterange-date m--font-brand"></span>
									</span>
									<a href="#" class="btn btn-sm btn-brand m-btn m-btn--icon m-btn--icon-only m-btn--custom m-btn--pill">
										<i class="la la-angle-down"></i>
									</a>
								</span>
							</div>
						</div>
						<br />

					<div className="content-wrapper">
		
		<form>
		<div class="container-fluid">
		<h4>Create a Workflow</h4>
		<hr />
		

		<div class="form-group row" >
		<label class="ContentTitle col-sm-2" >Workflow Name</label>
		<input id="workflowName" class="form-control input-medium col-sm-8" value={this.state.workflow.workflowName} onChange ={this.handleChange}/>
		</div>
			<div class="form-group row" >
		<label class="ContentTitle col-sm-2" >Workflow Owner</label>
		<input id="ownerId" class="form-control input-medium col-sm-8" value={this.state.workflow.ownerId} onChange ={this.handleChange}/>
		</div>

			<div class="form-group row" >
			<label class="ContentTitle col-sm-2" >Workflow Status</label>
			<select id="statusCode" class="form-control input-medium col-sm-8" value={this.state.workflow.statusCode} onChange ={this.handleChange}>
			{
				this.state.statusCodeList.map((status) => {
					return (
						<option key={status.systemCodeValueId} value={status.systemCodeValueId}>{status.systemCodeValueValue}</option>
					)
				})
			}
			</select>
			</div>
				<div class="form-group row" >
			<label class="ContentTitle col-sm-2" >Description</label>
			<input id="description" class="form-control input-medium col-sm-8" value={this.state.workflow.description} onChange ={this.handleChange}/>
			</div>
				<div class="form-group row" >
			<label class="ContentTitle col-sm-2" >Workflow Type</label>
			<select id="workflowTypeCode" class="form-control input-medium col-sm-8" value={this.state.workflow.workflowTypeCode} onChange ={this.handleChange}>
			{
				this.state.workflowTypeCodeList.map((status) => {
					return (
						<option key={status.systemCodeValueId} value={status.systemCodeValueId}>{status.systemCodeValueValue}</option>
					)
				})
			}
			</select>
			</div>
				<div class="form-group row" >
			<label class="ContentTitle col-sm-2" >Cases</label>
			<input id="workflowCases" class="form-control input-medium col-sm-8" value={this.state.workflow.workflowCases} onChange ={this.handleChange}/>
			</div>
				<div class="form-group row" >
			<label class="ContentTitle col-sm-2" >Annotations</label>
			<input id="annotations" class="form-control input-medium col-sm-8" value={this.state.workflow.annotations} onChange ={this.handleChange}/>
			</div>
				<div class="form-group row" >
			<label class="ContentTitle col-sm-2" >Content</label>
			<select id="contentId" class="form-control input-medium col-sm-8" value={this.state.workflow.contentId} onChange ={this.handleChange}/>
			</div>
				<div class="form-group row" >
			<label class="ContentTitle col-sm-2" >Manager</label>
			<select id="managerId" class="form-control input-medium col-sm-8" value={this.state.workflow.managerId} onChange ={this.handleChange}/>
			</div>
				<div class="form-group row" >
			<label class="ContentTitle col-sm-2" >Assignees</label>
			<input id="assignees" class="form-control input-medium col-sm-8" value={this.state.workflow.assignees} onChange ={this.handleChange}/>
			</div>
				<div class="form-group row" >
			<label class="ContentTitle col-sm-2" >Project</label>
			<input id="projectId" class="form-control input-medium col-sm-8" value={this.state.workflow.projectId} onChange ={this.handleChange}/>
			</div>
				<div class="form-group row" >
			<label class="ContentTitle col-sm-2" >Recipe</label>
			<input id="recipeId" class="form-control input-medium col-sm-8" value={this.state.workflow.recipeId} onChange ={this.handleChange}/>
			</div>

		
		<hr />	
					
					<button class="btn btn-primary" value="Clear" onClick ={this.handleClear}>Clear</button> &nbsp;
					<button class="btn btn-success" value="Create" onClick ={this.handleSubmit}>Create</button>&nbsp;
		</div>		
		</form>
						</div>		

	            </div>	
            </div>
            
			</div>
			</div>
	);
}
}